import { useEffect, useState } from "react";
import { profileImgSrc } from "../../config";
import { API_BASE_URL } from "../../config";
import "./ProffesionalsJobs.css";
import timeIco from "../../assets/employment-type-icon.svg";
import preferenceIco from "../../assets/preference-icon.svg";
import { getAuthToken } from "../../auth/auth";

export default function ProffesionalsMyJobs() {
  const [jobs, setJobs] = useState([]);
  const [statusFilter, setStatusFilter] = useState("active");
  const [loading, setLoading] = useState(false);

  const fetchJobs = async (filter) => {
    setLoading(true);

    try {
      const token = getAuthToken();

      let url = `${API_BASE_URL}/jobs/my-jobs`;

      if (filter) {
        url += `?status=${filter}`;
      }

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await response.json();

      if (data.success) {
        setJobs(data.data || []);
      }
    } catch (err) {
      console.error("Failed to load my jobs:", err);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchJobs(statusFilter);
  }, []);

  useEffect(() => {
    fetchJobs(statusFilter);
  }, [statusFilter]);

  return (
    <section id="proffesionals_jobs">
      <div className="container">
        <h1>My Jobs</h1>

        <div className="filter-wrapper proffesionals-filter-wrapper">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="active">Active Jobs</option>
            <option value="closed">Closed Jobs</option>
            <option value="applied">Applied Jobs</option>
            <option value="rejected">Rejected Jobs</option>
          </select>
        </div>

        {loading && <p className="loading-text">Loading jobs...</p>}

        {!loading && jobs.length === 0 && (
          <p className="no-jobs-text">No jobs found for selected filter.</p>
        )}

        <div className="proffesionals-jobs__all">
          {!loading &&
            jobs.map((job) => (
              <div className="proffesionals-jobs-single" key={job.id}>
                <div className="proffesionals-jobs-single__img">
                  <img
                    src={job.company_avatar || profileImgSrc}
                    alt="company"
                  />
                </div>

                <h3>{job.company_name}</h3>

                <div className="proffesionals-jobs-single__box">
                  <span>Job Name:</span>
                  <p>{job.title}</p>
                </div>

                <div className="proffesionals-jobs-single__box">
                  <span>Position:</span>
                  <p>{job.position}</p>
                </div>

                <div className="proffesionals-jobs-single__skills">
                  <span>Skills</span>
                  <div className="job-single__skills--wrapper">
                    {job.skills?.map((skill) => (
                      <span key={skill.id}>{skill.name}</span>
                    ))}
                  </div>
                </div>

                <div className="proffesionals-jobs-single__info">
                  <div className="proffesionals-jobs-single__info--single">
                    <img src={timeIco} alt="employment type" />
                    <p>{job.employment_type}</p>
                  </div>

                  <div className="proffesionals-jobs-single__info--single">
                    <img src={preferenceIco} alt="preferences" />
                    <p>{job.preferences?.map((p) => p.name).join(", ")}</p>
                  </div>
                </div>

                <div className="proffesionals-jobs-single__button--wrapper">
                  <button>Chat</button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
